import React, { useEffect, useState } from "react";
import "./PaymentSuccess.css";
import { setUserData } from "../../metaPixel";

export default function PaymentSuccess() {

  const [pedido,setPedido] = useState(null);

  const SCRIPT_URL =
  "https://script.google.com/macros/s/AKfycbzRpTEbdM6dzZwK7v_48aEJjNVivn-auestSaWDHNebj8kI73yW2CE9aZMihb8Wt-_g/exec";

  useEffect(()=>{

    const params = new URLSearchParams(window.location.search);

    const pedido_id = params.get("external_reference");
    const status = params.get("status");

    setPedido(pedido_id);

    if(!pedido_id) return;

    try {
      const salvo = localStorage.getItem("vf_pedido_" + pedido_id);
      const jaEnviado = localStorage.getItem("vf_purchase_" + pedido_id);

      if (window.fbq && salvo && !jaEnviado) {
        const { preco, kit, description, ud } = JSON.parse(salvo);
        setUserData(ud);
        window.fbq('track', 'Purchase', {
          value: parseFloat(String(preco).replace(',', '.')),
          currency: 'BRL',
          content_name: description || kit,
        }, { eventID: pedido_id });
        localStorage.setItem("vf_purchase_" + pedido_id, "1");
        localStorage.removeItem("vf_pedido_" + pedido_id);
      }
    } catch(e){}

    fetch(SCRIPT_URL,{
      method:"POST",
      body:new URLSearchParams({
        pedido_id:pedido_id,
        status:status || "approved"
      })
    });

  },[]);


  return(

    <div className="payment-page">

      <div className="payment-card">

        <div className="icon-sc">
          ✓
        </div>

        <h1>Pagamento aprovado!</h1>

        <p>
          Seu pedido foi confirmado com sucesso.
        </p>

        {pedido && (
          <p className="pedido">
            Pedido: <strong>{pedido}</strong>
          </p>
        )}

        <p className="ok">
          Pedido registrado com sucesso.
        </p>

        <button
          className="btn"
          onClick={()=>window.location.href="/"}
        >
          Voltar ao site
        </button>

      </div>

    </div>

  )

}